import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import FinanceAdminDashboard from "../finance_admin/FinanceAdminDashboard";
import AccountantDashboard from "../accountant/AccountantDashboard";
import MerchantDashboard from "../merchant/MerchantDashboard";
import ShopAdminDashboard from "../shop_admin/ShopAdminDashboard";
import { useEffect } from "react";

export default function UnifiedAdminDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { tenantSlug } = useParams();

  useEffect(() => {
    if (!user) navigate(`/${tenantSlug}/admin`);
  }, [user, navigate, tenantSlug]);

  if (!user) return null;

  switch (user.role) {
    case "finance_admin": return <FinanceAdminDashboard />;
    case "accountant": return <AccountantDashboard />;
    case "merchant": return <MerchantDashboard />;
    case "shop_admin": return <ShopAdminDashboard />;
    default:
      navigate(`/${tenantSlug}/admin`);
      return null;
  }
}
